/*
 * YSW Free Shipping Countdown.
 *
 */
var yswShippingCountdown = {
    selector: '.ysw-shipping-countdown',

    close: function () {
        $(document).on('click', yswShippingCountdown.selector + ' .close', function () {
            $(this).closest(yswShippingCountdown.selector).hide();
        });
    },

    update: function (cart) {
        var shippingIcon = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512' width='24px' height='24px' fill='white'><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d='M112 0C85.49 0 64 21.49 64 48V96H16C7.163 96 0 103.2 0 112C0 120.8 7.163 128 16 128H272C280.8 128 288 135.2 288 144C288 152.8 280.8 160 272 160H48C39.16 160 32 167.2 32 176C32 184.8 39.16 192 48 192H240C248.8 192 256 199.2 256 208C256 216.8 248.8 224 240 224H16C7.163 224 0 231.2 0 240C0 248.8 7.163 256 16 256H208C216.8 256 224 263.2 224 272C224 280.8 216.8 288 208 288H64V416C64 469 106.1 512 160 512C213 512 256 469 256 416H384C384 469 426.1 512 480 512C533 512 576 469 576 416H608C625.7 416 640 401.7 640 384C640 366.3 625.7 352 608 352V237.3C608 220.3 601.3 204 589.3 192L512 114.7C499.1 102.7 483.7 96 466.7 96H416V48C416 21.49 394.5 0 368 0H112zM544 237.3V256H416V160H466.7L544 237.3zM160 464C133.5 464 112 442.5 112 416C112 389.5 133.5 368 160 368C186.5 368 208 389.5 208 416C208 442.5 186.5 464 160 464zM528 416C528 442.5 506.5 464 480 464C453.5 464 432 442.5 432 416C432 389.5 453.5 368 480 368C506.5 368 528 389.5 528 416z'/></svg>"
        var html = '',
            cartHtml = '';
            yswShipping = document.getElementsByClassName('ysw-shipping-countdown'),
            yswShippingCountdown1 = yswShipping[0];

        let freeShippingAmount = " ";
        let currencySymbol = " ";
        let abbreviation = "";

        if (Shopify.currency.active == "USD") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmount);
            currencySymbol = "$";
            abbreviation = "";
        } else if (Shopify.currency.active == "EUR") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountEur);
            currencySymbol = "€";
        } else if (Shopify.currency.active == "AUD") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountAud);
            currencySymbol = "$";
            abbreviation = "AUD";
        }  else if (Shopify.currency.active == "GBP") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountGbp);
            currencySymbol = "£";
        }  else if (Shopify.currency.active == "CAD") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountCad);
            currencySymbol = "$";
            abbreviation = "CAD";
        }  else if (Shopify.currency.active == "CHF") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountChf);
            currencySymbol = "chf";
        }  else if (Shopify.currency.active == "NOK") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountNok);
            currencySymbol = "kr";
        }  else if (Shopify.currency.active == "DKK") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountDkk);
            currencySymbol = "kr";
        }  else if (Shopify.currency.active == "SEK") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountSek);
            currencySymbol = "kr";
        }  else if (Shopify.currency.active == "NZD") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountNzd);
            currencySymbol = "$";
            abbreviation = "NZD";
        }  else if (Shopify.currency.active == "RON") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountRon);
            currencySymbol = "lei";
        } else if (Shopify.currency.active == "CZK") {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmountCzk);
            currencySymbol = "Kč";
        } else {
            freeShippingAmount = Number(yswShippingCountdown1.dataset.freeShippingAmount);
            lcurrencySymbol = "$";
            abbreviation = "";
        }

        if (cart.total_price == 0) {
            let dollars = window.Shopify.formatMoney(freeShippingAmount, $('body').data('money-format')).replace('$', currencySymbol);
            html = `${shippingIcon} FREE SHIPPING ON ORDERS OVER <span class="money">${dollars} ${abbreviation}</span> `;
            cartHtml = '';
        } else if ( cart.total_price < freeShippingAmount) {
            let totalCart = freeShippingAmount - cart.total_price;
            let dollars = window.Shopify.formatMoney(totalCart, $('body').data('money-format')).replace('$', currencySymbol);
            html = `${shippingIcon} ADD <span class="money">${dollars} ${abbreviation}</span> TO UNLOCK FREE SHIPPING!`;
            cartHtml = `ADD ${dollars} TO UNLOCK FREE SHIPPING! <a href="index" class="continue-shopping">Continue Shopping</a><a href="#" class="close">x</a>`;
        } else {
            html = `${shippingIcon} CONGRATS, YOUR SHIPPING IS FREE`;
            cartHtml = '<span class="title">Your Shipping is Free!</span><a href="#" class="close">x</a>';
        }
        $(this.selector).not('.cart').html(html);
        $(this.selector + '.cart').html(cartHtml);
    },

    go: function () {
        this.close();
    }
}

$(document).ready(function () {
    yswShippingCountdown.go();

    if ($(window).width() <= 798) $(this).parents('.even-num-slides').removeClass('even-num-slides');
});
/* END YSW Free Shipping Countdown. */

const onObserve = (entries) => {
    entries.forEach(async (entry) => {
        if(!entry.isIntersecting) return;
        //observer.unobserve(entry.target);

        const { target } = entry;

        if (target.classList.contains('lazyload')) {
            if (target.dataset.src) {
                target.src = target.dataset.src;
            }

            if (target.dataset.srcset) {
                target.srcset = target.dataset.srcset;
            }

            if (target.dataset.sizes) {
                target.sizes = target.dataset.sizes;
            }

            target.classList.remove("lazyload");
            target.classList.add("lazyautosizes");
            target.classList.add("lazyloaded");
        }


    });
}

const options = {
    root: document.querySelector('.section-wrapper'),
    rootMargin: '0px',
    threshold: 1.0
}

const observer = new IntersectionObserver(onObserve, options);
let stampedWidget = document.querySelector('#stamped-reviews-widget');
let imgs = document.querySelectorAll('img.lazyload');

if(!stampedWidget) stampedWidget = document.querySelector('#stamped-main-widget');

if(stampedWidget) observer.observe(stampedWidget)
if(imgs.length) {
    imgs.forEach(img => {
        observer.observe(img);
    });
}
